import { Tooltip } from 'antd'
import { ReactElement } from 'react'

/** Секунда до показа: подпись нужна, только если курсор задержался на пункте */
const SHOW_DELAY_SEC = 1

export interface INavTooltipProps {
  label: string
  /** Управляемый показ; без него тултип открывается по наведению */
  open?: boolean
  /** Развёрнутое меню: подпись видна и без тултипа */
  disabled?: boolean
  children: ReactElement
}

export const NavTooltip = ({ label, open, disabled = false, children }: INavTooltipProps) => {
  return (
    <Tooltip
      mouseEnterDelay={SHOW_DELAY_SEC}
      open={open}
      placement={'right'}
      title={disabled ? '' : <span className={'text-[13px]'}>{label}</span>}
      {...(open !== undefined && { trigger: [] })}
    >
      {children}
    </Tooltip>
  )
}
